<template>
  <Modal v-model="arrivalDetailsModal" :title="$t('key1006318')" width="800" :transfer="false" @on-visible-change="arrivalDetailsChange">
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <Button type="primary" @click="arrivalDetailsModal = false">{{ $t('key1000316') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';

export default {
  name: "arrivalDetailsModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      arrivalDetailsModal: false,
      tableColumns: [
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 240,
          render(h, params) {
            let skuImg = '';
            let spuImg = '';
            let name = params.row.name;
            if (params.row._productInfo) {
              skuImg = params.row._productInfo.primaryImage;
              spuImg = params.row._productInfo._spuInfo.primaryImage;
              let primaryImage = skuImg || spuImg;
              return h('div', {class: 'flex mt5 mb5'}, [
                v.tableImg(h, params, null, primaryImage),
                h('div', {class: 'ml5'}, [
                  h('div', {class: 'flex align-items-start mb5'}, [
                    h('p', {
                      style: {
                        width: '70px',
                        textAlign: 'right'
                      }
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                    h('p', {
                      style: {
                        flex: 1
                      }
                    }, name),
                  ]),
                  h('div', {class: 'flex align-items-start mb5'}, [
                    h('p', {
                      style: {
                        width: '70px',
                        textAlign: 'right'
                      }
                    }, 'SKU：'),
                    h('p', {
                      style: {
                        flex: 1
                      }
                    }, params.row.ymsSku),
                  ]),
                  h('div', {class: 'flex align-items-start mb5'}, [
                    h('p', {
                      style: {
                        width: '70px',
                        textAlign: 'right'
                      }
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                    h('p', {
                      style: {
                        flex: 1
                      },
                      class: 'color-green'
                    }, params.row.variations),
                  ]),
                ])
              ]);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005925'),
          key: 'quantity',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005926'),
          key: 'allottedNumber',
          align: 'left'
        }
      ],
      tableData: [],
    };
  },
  methods: {
    // 初始化数据
    initArrivalDetailsData(ymsPlatformOrderId) {
      let v = this;
      v.tableData = [];
      let ymsProductGoodsIds = [];
      v.axios.get(api.get_ymsPlatformOrder + ymsPlatformOrderId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let ymsOrderInfo = data.ymsPlatformOrderPackageRelateds;
          if (ymsOrderInfo) {
            let list = [];
            ymsOrderInfo.forEach((item, index) => {
              if (item.ymsPackageInfo) {
                list.push(...item.ymsPackageInfo.ymsPackageGoods);
              }
            });
            if (list.length >0) {
              list.map((item) => {
                ymsProductGoodsIds.push(item.ymsProductGoodsId);
              });
              ymsProductGoodsIds = v.uniqueFunc(ymsProductGoodsIds);
              if (ymsProductGoodsIds.length > 0) {
                (async () => {
                  v.tableData = await v.getProductInfoByIds(ymsProductGoodsIds, list);
                })();
              }
            }
            v.arrivalDetailsModal = true;
          }
        }
      });
    },
    // 监听弹窗
    arrivalDetailsChange(value) {
      if (!value) {
        this.tableData = [];
      }
    }
  }
};
</script>

<style scoped>

</style>